export default "__VITE_ASSET__02a2b67e__"